import { Injectable } from '@angular/core';
import { Network } from '@ionic-native/network/ngx';
import { Platform } from '@ionic/angular';
import { BehaviorSubject, fromEvent } from 'rxjs';

@Injectable()
export class ConnectivityService {
  onDevice: boolean;
  userOnline = new BehaviorSubject<boolean>(false);
  isUserOnline;

  constructor(public platform: Platform, private network: Network) {
    this.managerConnectionStatus();
    this.onDevice = this.platform.is('cordova');
  }

  isOnline(): boolean {
    /* istanbul ignore else */
    if (this.onDevice && this.network.Connection) {
      return this.network.type !== 'none';
    } else {
      return navigator.onLine;
    }
  }

  managerConnectionStatus() {
    const isOnline = window.navigator.onLine;
    this.userOnline.next(isOnline);
    fromEvent(window, 'offline').subscribe(() => {
      this.userOnline.next(false);
    });
    fromEvent(window, 'online').subscribe(() => {
      this.userOnline.next(true);
    });

    if (this.onDevice) {
      this.network.onDisconnect().subscribe(() => this.userOnline.next(false));
      this.network.onConnect().subscribe(() => this.userOnline.next(true));
    }
  }
}
